module.exports = __webpack_public_path__ + "static/media/uk.b7449a1a.svg";